type TileProps = {
  label: string
  value: string
  caption: string
  accent?: string
}

/**
 * The figure tile the estimator and the trial panel both lay out. Shared so a
 * trial's dates and the price estimate cannot drift into looking like two
 * different kinds of number on the same card.
 */
export default function Tile({ label, value, caption, accent }: TileProps) {
  return (
    <div
      className="rounded-lg border px-3 py-3 text-center"
      style={
        accent
          ? { background: accent, borderColor: accent, color: '#ffffff' }
          : { background: '#ffffff', borderColor: '#e5e7eb' }
      }
    >
      <div className={`text-[10px] font-bold uppercase tracking-wider ${accent ? 'text-white/85' : 'text-gray-500'}`}>
        {label}
      </div>
      <div className={`mt-1 font-display text-xl font-bold leading-tight ${accent ? 'text-white' : 'text-gray-900'}`}>
        {value}
      </div>
      <div className={`mt-0.5 text-[11px] ${accent ? 'text-white/85' : 'text-gray-500'}`}>{caption}</div>
    </div>
  )
}
